module.exports = __webpack_public_path__ + "files/5f1e45ea87f01c65a008085b01a27262.png";